/**
 * The long moves' client runner in the effect registry (render/longMove.ts): wraps the Effects' event handling on its
 * first step (as the ports do, fx/sampleArt/port.ts), so the long-move events and the beats' hit-stop are seen after the
 * Effects' own handling, and steps the afterimages every frame. No fx ids of its own.
 */
import { longMoveOf, type WorldEvent } from '@nine/shared';
import { LONG_CINE, longMoveOnEvent, longMoveStep } from '../longMove';
import { registerFx, type FxHost } from './registry';

registerFx([], (host) => {
  let wrapped = false;
  return {
    step: () => {
      if (!wrapped) {
        wrapped = true;
        const h = host as FxHost & { handle(ev: WorldEvent): void };
        const inner = h.handle.bind(h);
        h.handle = (ev: WorldEvent): void => {
          inner(ev);
          // An ult's own camera (design §1.1: push ×1.12, never a takeover): the move's release keeps the dim and the
          // stamp the Effects gave it, not their full close-in.
          if (ev.type === 'skill' && longMoveOf(ev.skillId)?.kind === 'ult') {
            const c = host as unknown as { cineMax: number; cineT: number };
            c.cineMax = Math.min(c.cineMax, LONG_CINE);
            c.cineT = Math.min(c.cineT, 0.4);
          }
          longMoveOnEvent(host, ev);
        };
      }
      longMoveStep(host);
    },
  };
});
